import { AlertAction, AlertActionTypes, AlertMessage } from '../../types/alert';

const initialState: any = [];

export const alertReducer = (state = initialState, action: AlertAction) => {
  switch (action.type) {
    case AlertActionTypes.SET_ALERT:
      return [...state, action.payload];
    case AlertActionTypes.REMOVE_ALERT:
      return state.filter((alert: AlertMessage) => alert.id !== action.payload);
    default:
      return state;
  }
};
